
/**
 * `kioskApiPages`.
 */

const kioskApiPages = {
  kioskHome: 'kiosk-homepage'
};

/**
 * Export `de` api page routes.
 */

export const de = {
  ...kioskApiPages,
  aboutUs: 'uber-revigres',
  aboutUsSgiPolicy: 'politik-des-integrierten-managementsystems',
  careers: 'bewerbung',
  certificates: null,
  collection: null,
  collections: 'kollektionen',
  contacts: 'kontakt',
  cookiesPolicy: 'cookie-richtlinie',
  downloads: 'downloads',
  environment: 'umwelt',
  faq: null,
  faqs: 'haufig-gestellte-frage',
  fundedProjects: null,
  highlights: 'highlights',
  history: 'geschichte',
  home: 'homepage',
  innovation: 'innovation',
  inspiration: 'inspiration',
  inspirationDetails: 'inspiration-detail',
  lightXl: 'light-xl',
  media: 'medien',
  portfolio: 'portfolio',
  portfolioDetails: 'portfolio-detail',
  privacyPolicy: 'datenschutzpolitik',
  productContact: 'produkt-kontakt-uns',
  productDetails: null,
  recommend: 'empfehlungstool',
  recommendResults: null,
  reportingChannel: 'berichtskanal',
  socialResponsability: 'soziale-verantwortung',
  storytiling: 'storytiling',
  storytilingDetails: 'storytiling-detail',
  tech20mm: 'tech-20mm',
  termsConditions: 'allgemeine-geschaftsbedingungen',
  toolsBimObjects: 'bim',
  toolsEnvironmentSimulator: 'umgebungssimulator',
  toolsProductComparator: 'komparator',
  whereToBuy: 'verkaufsstellen',
  whereToBuyResults: 'verkaufsstellen-resultate'
};
